import * as React from 'react';
import { TreeContext } from './Context';
import { INodeProps, ITreeData } from './types';
import { Group } from './Group';
import { useState } from 'react';

interface ITreeProps {
    node?: React.FC<INodeProps>;
    data?: ITreeData[];
    onSelect: (item: ITreeData) => void;
}

export const Tree = ({ data = [], node, onSelect }: ITreeProps) => {
    const recurseSetVisible = (item: ITreeData) => {
        const parent = data.find((e) => e.id === item.parentId);
        if (parent) {
            parent.isExpanded = true;
            recurseSetVisible(parent);
        }
    };

    const buildData = (): ITreeData[] => {
        const hasSelected = data.find((e) => e.isSelected);
        if (hasSelected) {
            recurseSetVisible(hasSelected);
        }

        return data;
    };

    const [dataItems, setDataItems] = useState(buildData());

    React.useEffect(() => {
        setDataItems(buildData());
    }, [data])

    const handleOnSelect = (item: ITreeData) => {
        if (dataItems) {
            // unselect one.
            dataItems.forEach((e) => (e.isSelected = false));

            // select one
            dataItems.find((e) => e.id === item.id)!.isSelected = true;

            // set state
            setDataItems([...dataItems]);
        }

        onSelect(item);
    };

    return (
        <TreeContext.Provider value={{ data: dataItems, node, onSelect: handleOnSelect }}>
            <Group parentId="0" />
        </TreeContext.Provider>
    );
};
